import React from 'react'
import { DefaultDataTable } from '../../../components/dataTable/DefaultDataTable'
export const ContaCorrenteList = (props) => <DefaultDataTable data={props} />
